/**
 * Master status values for a StudentInSchoolRecord (MasterStatusID) that drive
 * enrollment-card visibility and stage rules. Only the statuses those rules reference
 * are listed; all other statuses (Graduated, Withdrawn, NotApplicable, ...) simply
 * pass through the filters.
 */
export enum EnrollmentMasterStatus {
    Applied = 1,
    Enrolled = 2,
    Accepted = 6,
    Waitlist = 7,
    ReEnrolled = 9,
    SecondaryEnrollment = 71,
}
